import TaskShow from './tasks/show'
import TaskList from './tasks'

const routes = [
  { path: '/tasks/:view(all|to_me|by_me|upcoming|overdue|completed)', component: TaskList },
  { path: '/tasks/:id/:view', component: TaskShow }
]

export default routes
